export default "__VITE_ASSET__BS$7YB4m__"